<template>
  <div>
    <div
      class="aspect-4/3 md:aspect-21/9 bg-cover bg-center relative"
      :style="{ backgroundImage: `url(${page?.image?.url})` }">
      <div class="absolute inset-0 pointer-events-none bg-scrim-full" />
      <div class="standard-spacing flex flex-col justify-center items-center h-full absolute inset-0">
        <h1 class="heading-1 text-center">
          {{ page?.title }}
        </h1>
      </div>
      <div v-if="formattedPublishedDate" class="absolute bottom-0 right-0 left-0 pointer-events-none">
        <div class="subheading standard-spacing mb-8 text-right">Published {{ formattedPublishedDate }}</div>
      </div>
    </div>
    <Navbar />
    <div class="bg-gradient-watermelon standard-spacing-y">
      <div class="standard-spacing relative">
        <div class="max-w-4xl mx-auto">
          <ClientOnly>
            <DocumentContent :contents="page?.content?.document" className="blog-content" />
          </ClientOnly>
        </div>
        <div class="standard-spacing-t flex items-center justify-center w-full">
          <HoapButton label="Contact us" inverted url="/contact-us" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import dayjs from 'dayjs'
  import { getBlogQuery } from '~/queries/blog'

  const route = useRoute()
  const axios = useAxios()

  const slug = computed(() => route.params.slug)

  const { data: page } = await useAsyncData(`${slug.value}`, async () => {
    const { data } = await axios.post(
      '/api/graphql',
      {
        query: getBlogQuery,
        variables: {
          slug: slug.value,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    // This isnt great, the query should accommodate for this check,
    // but keystone doesn't allow boolean fields to be used in unique queries
    if (data.data.blog.published != true) throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })

    return data.data.blog
  })

  if (!page.value) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
  }

  const formattedPublishedDate = computed(() =>
    page.value?.publishedAt ? dayjs(page.value?.publishedAt).format('DD/MM/YYYY') : null
  )

  setMetadata({
    pageTitle: page?.value?.title,
    pageDescription: page?.value?.seoDescription,
    keywords: page?.value?.seoKeywords,
    imageUrl: page?.value?.seoImage?.url ?? page?.value?.image?.url,
  })
</script>
